import { Grid, Typography, createStyles, makeStyles } from '@material-ui/core';
import { isSpecialPlan } from 'data-layer-cr/dist/functions/quotations';
import { QuotationSummaryResponse } from 'data-layer-cr/dist/models';
import { moneyFormat } from 'design-system';
import React from 'react';
import CardQuotation from '../CardQuotation';

const { formatMoney } = moneyFormat;

type Props = {
  quotationSummary: QuotationSummaryResponse;
};

const useStyles = makeStyles(() =>
  createStyles({
    titleFontStyle: {
      fontSize: '19px',
      fontWeight: 900,
    },
  }),
);

const SummaryCarDetailsCard = ({ quotationSummary }: Props): JSX.Element => {
  const defaultFooter = {
    Value: 'Suma asegurada',
    Text: formatMoney(
      quotationSummary.insuranceValue,
      false,
      quotationSummary.profile.typeOfMoney,
    ),
  };

  const classes = useStyles();

  const packageName: React.ReactNode = (
    <Grid container style={{ paddingBottom: '7px' }}>
      <img
        src="/svg/steering_wheel.svg"
        alt="steering wheel"
        style={{ marginRight: 11 }}
      />
      <Typography className={classes.titleFontStyle}>Datos del auto</Typography>
    </Grid>
  );

  return (
    <CardQuotation
      data-testid="summaryCardDetails-cardQuotation-container"
      title={packageName}
      subTitle={
        <div>
          {isSpecialPlan(quotationSummary.profile)} {quotationSummary.carBrand}{' '}
          {quotationSummary.carModel}
        </div>
      }
      defaultDataList={[
        { Value: 'Año', Text: quotationSummary.carYear.toString() },
      ]}
      defaultFooter={defaultFooter}
    />
  );
};

export default SummaryCarDetailsCard;
